import { ListingAction } from '../../../components/Listing/types/ListingAction';
import {
  APIListingAction,
  APIListingActionType,
  APIListingItem,
} from '../types';

/**
 * Converts API Listing's action payload into the format required for the listing item's action buttons
 * where the data is passed into the handler / modal that is triggered by the action button.
 *
 * Remaining types still to be handled will include
 * - LowerReserveReferred
 * - AcceptOffer
 * - RejectOffer
 * - Promote
 * - Review
 */
export function mapListingAction<T extends APIListingActionType>(
  action: APIListingAction<T>,
  apiListing: APIListingItem
): ListingAction {
  switch (action.actionType) {
    case 'HoldReserve':
      return {
        type: 'hold-reserve',
        isPrimary: action.isPrimary,
        title: action.displayName,
        data: {
          ...action.data,
        },
      };
    case 'AcceptBid':
      return {
        type: 'accept-bid',
        isPrimary: action.isPrimary,
        title: action.displayName,
        data: {
          ...action.data,
        },
      };
    case 'LowerReserveReferred':
      return {
        type: 'lower-reserve-referred',
        isPrimary: action.isPrimary,
        title: action.displayName,
        data: {
          ...action.data,
          bid: apiListing.price!,
        },
      };
    case 'LowerReserveAuction':
      return {
        type: 'lower-reserve-auction',
        isPrimary: action.isPrimary,
        title: action.displayName,
        data: {
          ...action.data,
          bid: apiListing.price!,
        },
      };
  }
}
